import * as _ from 'lodash'

function locationSetting(state = {}, action = {}) {
  if (action.type === 'GETLOCATIONSETTING_SUCCESS') {
    return _.get(action, 'response.json', null)
  }

  if (action.type === 'UPDATELOCATIONSETTING_SUCCESS') {
    return { ...state, ..._.get(action, 'response.json', {}) }
  }

  return state
}

export default locationSetting
